import { TranslateService } from "@ngx-translate/core";

export class MeasurementModeName {
  objectDistance: string;
  distance: any;
  pointToLine: string;
  depth: string;
  lines: string;
  area: string;
  polyline: string;
  tipDefect: string;

  constructor(translate: TranslateService) {
    this.objectDistance = translate.instant("imageRemeasurementEdit.objectDistance");
    this.distance = translate.instant("imageRemeasurementEdit.distance");
    this.pointToLine = translate.instant("imageRemeasurementEdit.pointToLine");
    this.depth = translate.instant("imageRemeasurementEdit.depth");
    this.lines = translate.instant("imageRemeasurementEdit.lines");
    this.area = translate.instant("imageRemeasurementEdit.area");
    this.polyline = translate.instant("measurement.Polyline");
    this.tipDefect = translate.instant("measurement.TipDefect");
  }
}
